export enum TranslateError {
  ErrUnknown = 0,
  /** 点数不足 */
  ErrVideoCreditsNotEnough = 1,
  /** 编辑数不足 */
  ErrVoiceEditsNotEnough = 2,
  /** 存储数不足 */
  ErrVoiceSlotsNotEnough = 3,
}
